import isMobile from 'ismobilejs';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Loading from '../CircularLoading';
import { fetchViberQRCode } from '../../actions/integrations';

import LinkRequestChannelContent from './LinkRequestChannelContent';

class ViberChannelContentComponent extends Component {
    static propTypes = {
        channelState: PropTypes.object.isRequired,
        ui: PropTypes.object.isRequired,
    };

    render() {
        const {
            channelState,
            ui: { text },
        } = this.props;

        if (isMobile().any) {
            return <LinkRequestChannelContent type="viber" channelState={channelState} />;
        }

        if (channelState.hasError) {
            return (
                <a className="error-link" onClick={fetchViberQRCode}>
                    {text.viberQRCodeError}
                </a>
            );
        }

        if (channelState.qrCode) {
            return <img alt="Viber QR Code" style={{ width: '40%' }} src={channelState.qrCode} />;
        }

        const loadingStyle = {
            height: 40,
            width: 40,
            margin: 'auto',
        };

        return <Loading dark={true} style={loadingStyle} />;
    }
}

export default connect(
    ({ ui }) => {
        return {
            ui,
        };
    },
    null,
    null,
    { forwardRef: true },
)(ViberChannelContentComponent);
